import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './locales/zh'
import en from './locales/en'
import ElementLocale from 'element-ui/lib/locale'
import settings from '../settings'

Vue.use(VueI18n)

const locale = settings.language || 'zh'

const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: 'zh',
  messages: {
    zh,
    en
  }
})

// 配置 Element UI 国际化
ElementLocale.i18n((key, value) => i18n.t(key, value))

// 根据初始语言设置 Element UI 语言
if (locale === 'zh') {
  ElementLocale.use(require('element-ui/lib/locale/lang/zh-CN').default)
} else {
  ElementLocale.use(require('element-ui/lib/locale/lang/en').default)
}

export default i18n
